import { c as _c } from "react/compiler-runtime";
import { makeFf, makeSwrFf } from "./ffetch";
import { makeNg } from "./ng";
import type { AnyJson, EmptyObject, Fetch, NgProps, ScProps } from "./types";

/**
 * makeSC(<非同期関数>)(<コンポーネント>) は、<非同期関数>を実行し、その結果を元に<コンポーネント> を描画する関数
 * <コンポーネント> は、引数として<非同期関数>の実行結果と、_refetch という非同期関数を受け取れる
 * _refetch を呼び出すと、<非同期関数> を再実行し、その結果を元に <コンポーネント> を再描画する
 */
export const makeSequentialComponent = <U extends AnyJson, T extends AnyJson = EmptyObject>(fetch: Fetch<T, U>, options?: {
  swr?: boolean;
  Loading?: React.FC<T>;
}) => {
  const useFf = options?.swr ? makeSwrFf(fetch) : makeFf(fetch);
  const Loading: React.FC<T> = options?.Loading || (() => <></>);
  return <V extends AnyJson = EmptyObject,>(Ok: React.FC<T & U & V & ScProps>, Ng?: React.FC<NgProps<T & V>>) => {
    const NgNet = makeNg<T & V>(Ng);
    const SequenceComponent: React.FC<T & V> = props => {
      const $ = _c(11);
      const [seqState, refetch] = useFf(props);
      switch (seqState.status) {
        case "ok":
          {
            let t0;
            if ($[0] !== props || $[1] !== refetch || $[2] !== seqState.data) {
              t0 = <Ok {...props} {...seqState.data} _refetch={refetch} />;
              $[0] = props;
              $[1] = refetch;
              $[2] = seqState.data;
              $[3] = t0;
            } else {
              t0 = $[3];
            }
            return t0;
          }
        case "ng":
          {
            let t0;
            if ($[4] !== props || $[5] !== seqState.error) {
              t0 = <NgNet error={seqState.error} {...props} />;
              $[4] = props;
              $[5] = seqState.error;
              $[6] = t0;
            } else {
              t0 = $[6];
            }
            return t0;
          }
        case "loading":
          {
            let t0;
            if ($[7] !== props) {
              t0 = <Loading {...props} />;
              $[7] = props;
              $[8] = t0;
            } else {
              t0 = $[8];
            }
            return t0;
          }
        default:
          {
            let t0;
            if ($[9] !== props) {
              t0 = <Loading {...props} />;
              $[9] = props;
              $[10] = t0;
            } else {
              t0 = $[10];
            }
            return t0;
          }
      }
    };
    return SequenceComponent;
  };
};